Platform.Deferred.execute(setCartCheckoutScript);

function setCartCheckoutScript() {
    root = $('body').data('root');

    LoadCheckoutCart();
}

function LoadCheckoutCart(callback) {
    var showDiscount = $('.pf-checkout-cart-loader').data('show-discount');
    var getCartUrl = root + 'cart/GetCart' + (showDiscount ? '?showDiscount=true' : '?showDiscount=false');
    $('.pf-checkout-cart-loader').load(getCartUrl, function () {
        if (callback)
            callback();
    });
}

// Register handlers for cart actions
$(document).on('itemUpdated.cart.platform', function (event, data) {
    LoadCheckoutCart(function () {
        //$(".pf-checkout-cart-loader .checkout-cart-footer-row").highlight();  
    });
});

$(document).on('itemRemoved.cart.platform', function (event, data) {
    LoadCheckoutCart(function () {
        //$(".pf-checkout-cart-loader .checkout-cart-footer-row").highlight();
    });
});

$(document).on('discountUpdated.cart.platform', function (event, data) {
    LoadCheckoutCart(function () {
        //$(".pf-checkout-cart-loader .checkout-cart-footer-row").highlight();
    });
});


var relatedDiv = document.getElementById('RelatedRecentlyProducts');
if (relatedDiv !== null) {
    $('#RelatedRecentlyProducts').load(root + "Products/RelatedRecentlyProducts");
}

function openTab(evt, tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("w-tab-pane");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("w-tab-link");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" w--current", "");
    }
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " w--current";
}